import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  table: {
    '& .MuiTableRow-root': {
      cursor: 'pointer'
    }
  }
}));
